import styles from "./acardeon.module.css";
import { useMeals, useMealsAction } from "../../../../Context/MealsProvider";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import { AiOutlinePlus } from "react-icons/ai";
const Acardeon = ({ index, dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}-${dayIndex}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div>
      <p>
        <button className={`btn ${styles.btnacardeon}`} type="button" onClick={toggleAccordion}>
          <AiOutlinePlus />
        </button>
      </p>
      <div className="collapse" id={`accordion-${index}-${dayIndex}`}>
        <div>
          <div className={styles.containerAcardeon}>
            <div className={styles.containerMain}>
              <div className={styles.formInput}>
                <p className={styles.text}> نوع </p>
                <select
                  class="form-select form-select-sm"
                  aria-label=".form-select-sm example"
                  className={styles.inputBox}
                  value={meals[dayIndex][index].noeEghamat}
                  onChange={(e) =>
                    dispatch({
                      day: dayIndex,
                      type: "changeHandlerNoeEghamat",
                      id: index,
                      event: e,
                    })
                  }
                >
                  <option selected className={styles.selected}></option>
                  <option value="1">هتل</option>
                  <option value="2">هتل آپارتمان</option>
                  <option value="3">اقامتگاه بوم گردی</option>
                  <option value="4">خانه محلی</option>
                  <option value="5">کمپ</option>
                </select>
              </div>

              <div className={styles.formInput}>
                <p className={styles.text}>نام</p>
                <input
                  type="text"
                  className={styles.inputBox}
                  value={meals[dayIndex][index].onvan}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerOnvan",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                />
              </div>
              <div className={styles.formInput}>
                <p className={styles.text}>شماره</p>
                <input
                  type="text"
                  className={styles.inputBox}
                  value={addCommas(meals[dayIndex][index].tel)}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerTel",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                />
              </div>
              <div className={styles.formInput}>
                <p className={styles.text}>آدرس</p>
                <textarea
                  type="text"
                  className={styles.inputBoxbig}
                  value={meals[dayIndex][index].address}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerAddress",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Acardeon;
